import { z } from 'zod';

export const runNameSchema = z.object({
  runName: z.string().trim().max(100, { message: 'Run name must be 100 characters or less' }),
});

export type RunNameFormData = z.infer<typeof runNameSchema>;
